/**
 * O "normal" de temperatura DA PESSOA (B-45, decidido em 16/10/2026).
 *
 * O sensor le a pele, e o numero que a pulseira entrega e uma estimativa dela - o
 * painel mostrava a variacao contra 36 °C fixos, igual para todo mundo. O app mostra
 * contra a MEDIANA da propria pessoa nos ultimos 14 dias, e o painel passa a falar a
 * mesma lingua. As constantes espelham `TemperatureBaseline.kt` do app.
 *
 * A mediana, e nao a media: uma leitura fora do pulso (o aparelho na mesa marca a
 * temperatura do ambiente) desloca a media e nao mexe na mediana.
 */
/** Minimo de leituras para haver "seu normal". Com menos, o desvio diria mais do acaso. */
export const TEMPERATURE_BASELINE_MIN_SAMPLES = 10;
/** A janela do normal: duas semanas cobrem a rotina sem virar historia antiga. */
export const TEMPERATURE_BASELINE_DAYS = 14;
/** A mediana das leituras, ou `undefined` quando nao ha leituras bastantes. */
export function temperatureBaseline(values) {
    const valid = values.filter((value) => Number.isFinite(value) && value > 0);
    if (valid.length < TEMPERATURE_BASELINE_MIN_SAMPLES) {
        return undefined;
    }
    const sorted = [...valid].sort((left, right) => left - right);
    const middle = Math.floor(sorted.length / 2);
    return sorted.length % 2 === 1 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
}
/** `yyyy-mm-dd` do primeiro e do ultimo dia da janela do normal, terminando em `today`. */
export function temperatureBaselineWindow(today = new Date()) {
    const end = new Date(today);
    const start = new Date(today);
    start.setDate(start.getDate() - (TEMPERATURE_BASELINE_DAYS - 1));
    const iso = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    return { startDate: iso(start), endDate: iso(end) };
}
//# sourceMappingURL=temperature.js.map